var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"width":"200px"},attrs:{"src":"https://cdn.cloudious.net/e39a7eea-3346-4cf3-9064-b832acce887d.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }